<template>
  <!-- 学历统计 -->
  <div>
    <div class="table-top">
    </div>
    <!-- 表格   -->
    <el-table
      v-el-table-infinite-scroll="load"
      :data="tableData"
      stripe
      style="width: 100%"
      height="550"
      :header-cell-style="{background:'#FAFAFA',color:'#606266'}"
      :row-style="{height: '10px'}"
    >
      <el-table-column
        type="index"
        label="排名"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="teacherName"
        label="姓名"
        width="100"
      >
      </el-table-column>
      <el-table-column label="活跃度">
        <template slot-scope="scope">
          <el-progress
            :percentage="scope.row.totalScoreRatio"
            :format="scoreFormat"
            :color="customColorMethod"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastTime"
        label="最近登录"
        width="190"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
//无限滚动插件
import elTableInfiniteScroll from "el-table-infinite-scroll";
export default {
  directives: {
    "el-table-infinite-scroll": elTableInfiniteScroll,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      pageObj: {
        current: 1,
        size: 10,
      },
      notHave: false,//是否还有数据
      maxScore: "",
      tableData: [],
    }
  },
  // mounted() {
  //   this.activeLsit(this.pageObj.current, this.pageObj.size);
  // },
  methods: {
    //活跃度榜单
    activeLsit(curPage, pageSize) {
      let homeForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        // teacherId: this.userInfo.userId,
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        // schoolTerm: this.searchTerm || "",
        // schoolYear: this.searchYear || "",
        // keyword: this.searchKey || "",
      };
      this.$axios
        .post("/rpt/getTeacherActiveList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.notHave = res.data.records.length<this.pageObj.size;
            this.maxScore = this.maxScore ? this.maxScore : (res.data.records[0].totalScore + 5);
            this.tableData =  this.tableData.concat(res.data.records);
            this.tableData.forEach((item) => {
              //转化成百分比，保留整数
              item.totalScoreRatio = parseInt(
                ((parseInt(item.totalScore) / this.maxScore) * 100).toFixed(0)
              );
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    scoreFormat(percentage) {
      //根据积分比例返回 积分值
      let a = this.tableData.find(
        (item) => item.totalScoreRatio === percentage
      );

      return a ? a.totalScore : "";
    },
    customColorMethod(percentage) {
      if (percentage > 89) {
        return "#FF7250";
      } else if (percentage > 79) {
        return "#FFD900";
      } else if (percentage > 69) {
        return "#597EF7";
      } else {
        return "#36CB8C";
      }
    },

    //滑动加载
    load() {
      // console.log("el-table 已经滚到底部");
      //进来后会执行一次
      if(this.notHave){
        // console.log("没有数据了");
        return
      }
      this.activeLsit(this.pageObj.current, this.pageObj.size);
      this.pageObj.current++;
    },
  },
};
</script>

<style lang="less" scoped>
.table-top {
  width: 580px;
  height: 50px;
  background-color: #fff;
  border-radius: 10px 10px 0px 0px;
}
.el-table {
  border-radius: 0px 0px 10px 10px;
  padding: 0px 20px;
}
</style>
